import React from 'react';
import PropertyList from './PropertyList';
import { formatMoney } from '../../util/araknerdlib';

const PlanCard = ({ plan, variant, onGenerate, selected }) => {

  return (
    <div className="col-lg-3 col-sm-6">
      <div className={`card card-pricing custom-card plan-card ${selected ? 'plan-selected' : ''}`}>
        {/* Header (fixed) */}
        <div className="plan-header bg-transparent border-0">
          <div className="pricing-title">
            {plan.name}
          </div>
          <h1 className="h1 font-weight-normal text-center mb-0" data-pricing-value={plan.price}>
            <span className="price text-success"> {formatMoney(plan.price, plan.currency)}</span>
            <span className="text-muted text-12 ml-2">/voucher</span>
          </h1>
        </div>

        {/* Body (scrollable) */}
        <div className="plan-body overflow-auto">
          <PropertyList plan={plan} />
        </div>

        {/* Footer (fixed) */}
        <div className="plan-footer text-center">
          <button
            className="btn ripple btn-outline-light w-100"
            onClick={() => onGenerate(plan)}
          >
            Generate Voucher
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;